// script to detect scrolling for header
(() => {
  const main = document.querySelector('main');
  const header = document.querySelector('.header');
  const scrolled = 'scrolled';
  
  if(!main || !header) {
    return;
  }

  const trigger = document.createElement('div')
  trigger.classList.add('scroll-trigger');
  main.prepend(trigger);

  const observer = new IntersectionObserver((entries, observer) => {
    entries
      .forEach((entry) => {
        if(entry.isIntersecting) {
          header.classList.remove('scrolled');
        }
        else {
          header.classList.add('scrolled');
        }
      });
  },
  {
    rootMargin: '0px 0px 0px 0px',
    threshold: 1.0
  });

  observer.observe(trigger);
})();